// components
import LocationLogMobile from "./locationLog_mobile";

// react
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";

// css
import styles from './location_mobile.module.css';
import { getLocation } from "../../../service/log/locationLogService";
import { getFile } from "../../../service/mngt/elderService";

// services
// import { Map, LatLng, Marker } from 'kakao-maps-sdk';

function LocationMobile({ conn }) {

  const { kakao } = window;

  const location = useLocation();
  const mapContainer = useRef(null);
  let map;
  let defaultMarker;
  let markers;
  let circle;
  let linePath = [];
  let polyline;

  const [dataSource, setDataSource] = useState({
    locationLogList: [],
  })
  const [dataState, setDataState] = useState({
    userId: location.state.userId,
    lat: location.state.lat,
    lng: location.state.lng,
    userGender: location.state.userGender,
    gathDtm: new Date(),
    newCenter: null,
  })
  const [logState, setLogState] = useState({
    height: "5vh",
    visible: false,
    overflow: "hidden"
  });
  const [imgFile, setImgFile] = useState({
    imgFileUserPhoto: null,
  });
  const [currentLocation, setCurrentLocation] = useState();

  // 현재 위치 이동
  const moveCurrentLocation = () => {
    if(currentLocation === undefined) {

    } else {
      currentLocation.map.setCenter(new kakao.maps.LatLng(parseFloat(currentLocation.lat), parseFloat(currentLocation.lng)))
    }
  }

  const plusLog = () => {
    if(logState.visible) {
      setLogState(logState => {
        const item = { ...logState };
        item.height = "5vh";
        item.visible = false;
        item.overflow = "hidden";
        return item;
      })
    } else {
      setLogState(logState => {
        const item = { ...logState };
        item.height = "40vh";
        item.visible = true;
        item.overflow = "auto";
        return item;
      })
    }
  }

  const getData = () => {
    getLocation(conn, dataState)
    .then(result => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.locationLogList = result;
        return item;
      })
      const lastIndex = result.length - 1;
      let markersImage = "/images/mobile/marker/marker";

      // 대상자 사진이 있을 때 
      if(location.state.fileIdUserPhoto) {
        getFile(conn, location.state.fileIdUserPhoto)
        .then(fileResponse => {
          const dataUri = 'data:image/png;base64,' + fileResponse;
          result.map((item, index) => {
            markers = new kakao.maps.Marker({
              map: map,
              position: new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)),
              zIndex: lastIndex - (index - 1),
              image: index === 0 ?
                  // new kakao.maps.MarkerImage(dataUri, new kakao.maps.Size(45, 45))
                  new kakao.maps.MarkerImage(location.state.userGender === "M" ? markersImage + "_60_grandfather.png" : markersImage + "_60_grandmother.png", new kakao.maps.Size(45, 45))
                  : new kakao.maps.MarkerImage(markersImage + (lastIndex - (index - 1)) + ".png", new kakao.maps.Size(30, 30))
            })
            if(index === 0) {
              // Change the center of the map
              map.setCenter(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)))

              setCurrentLocation((currentLocation) => {
                const data = { ...currentLocation };
                data.map = map;
                data.lat = item.lat;
                data.lng = item.lng;
                return data;
              })

              const customOverlay = new kakao.maps.CustomOverlay({
                position: new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)),
                content: '<div classNmae="custom-marker"></div>',
                // map: map,
                yAnchor: 1
              });
              // customOverlay.setMap(map)
            }
            // Add marker positions to the polyline points array
            linePath.push(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)));
            drawLine();
          })
        })
        .catch(err => {
          console.log("getFile err = ", err);
        })
      } else {
      // 대상자 사진이 없을 때 
        result.map((item, index) => {
          markers = new kakao.maps.Marker({
            map: map,
            position: new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)),
            zIndex: lastIndex - (index - 1),
            image: index === 0 ?
              new kakao.maps.MarkerImage(location.state.userGender === "M" ? markersImage + "_60_grandfather.png" : markersImage + "_60_grandmother.png", new kakao.maps.Size(45, 45))
              : new kakao.maps.MarkerImage(markersImage + (lastIndex - (index - 1)) + ".png", new kakao.maps.Size(30, 30))
          })
          if(index === 0) {
            // Change the center of the map
            map.setCenter(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)))

            setCurrentLocation((currentLocation) => {
              const data = { ...currentLocation };
              data.map = map;
              data.lat = item.lat;
              data.lng = item.lng;
              return data;
            })
            
          }
          // Add marker positions to the polyline points array
          linePath.push(new kakao.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng)));
          drawLine();
        })
      }
    })
    .catch(err => {
      console.log("getLocation err = ", err);
    })
  }

  // 원 그리기
  const drawCircle = () => {
    const circle = new kakao.maps.Circle({
      center:  new kakao.maps.LatLng(dataState.lat, dataState.lng),  // 원의 중심좌표 입니다 
      radius: 1000, // 미터 단위의 원의 반지름입니다 
      strokeWeight: 1, // 선의 두께입니다 
      strokeColor: '#90d0d1', // 선의 색깔입니다
      strokeOpacity: 0, // 선의 불투명도 입니다 1에서 0 사이의 값이며 0에 가까울수록 투명합니다
      strokeStyle: 'dashed', // 선의 스타일 입니다
      fillColor: '#44c7be', // 채우기 색깔입니다
      fillOpacity: 0.4, // 채우기 불투명도 입니다
      // map: map,  
    })      
    // 지도에 원을 표시합니다 
    circle.setMap(map);
  }
  
  // 선 그리기
  const drawLine = () => {
    const polyline = new kakao.maps.Polyline({
      path: linePath,
      strokeWeight: 4,
      strokeColor: '#3d948e',
      strokeOpacity: 0.8,
      strokeStyle: 'solid',
      // map: map,
    });
    // Add the polyline to the map
    polyline.setMap(map);
  }

  useEffect(() => {

    // 마커 불러오기
    getData();

    // 위도, 경도, 맵 레벨 설정
    const mapOptions = {
      center: new kakao.maps.LatLng(dataState.lat, dataState.lng),
      level: 8,
    };
    // 지도 생성
    map = new kakao.maps.Map(mapContainer.current, mapOptions);

    // 설비 위치 마커 이미지 설정
    const defaultMarkerImg = "/images/mobile/marker/marker_60_home.png"
    // 대상자 설비 위치 마커 표시
    const markerPosition = new kakao.maps.LatLng(dataState.lat, dataState.lng); // Replace with your desired latitude and longitude
    defaultMarker = new kakao.maps.Marker({
      position: markerPosition,
      image: new kakao.maps.MarkerImage(defaultMarkerImg, new kakao.maps.Size(60, 60)),
      map: map,
    });

    drawCircle();

    // 줌 확대, 축소 이벤트
    kakao.maps.event.addListener(map, 'zoom_changed', () => {
      const currentZoomLevel = map.getLevel();
    });

    // 지도 클릭 이벤트
    kakao.maps.event.addListener(map, 'click', (mouseEvent) => {
      const clickedLatLng = mouseEvent.latLng;
      // marker.setPosition(clickedLatLng);
    });
    // 구성 요소가 마운트 해제될 때 맵 인스턴스를 정리
    // 맵과 관련된 모든 이벤트 리스너 또는 리소스가 적절하게 제거되어 메모리 누수를 방지
    return () => {
      kakao.maps.event.removeListener(map);
    };

  }, [])
  return (
    <>
      <div className="pageContentMap_m">
        <div className={styles.locationMap} ref={mapContainer} style={{ width: "100vw", height: "84vh" }}></div>
        <div className={styles.currentLocationButton} onClick={moveCurrentLocation}><img style={{width: "30px", height: "30px"}} src="/images/currentLocation_white.png"></img></div>
        <div className={styles.locationLog}>
          <div className={styles.locationLogTop}>
            <div className={styles.top1}>{location.state.userTerm}</div>
            <div className={styles.top2} onClick={plusLog}><button className={styles.plusBtn}></button></div>
            <div className={styles.top3}>{kendo.toString(new Date(),"yyyy.MM.dd")}</div>
          </div>
          <br/>
          <div className={styles.locationLogBottom} style={{height: logState.height, overflow: logState.overflow}}>
            <div className={styles.locationLogList}>
              <div className={styles.locationLogListLeft}>
                {dataSource.locationLogList.length ? (
                  dataSource.locationLogList.map((item, index) => {
                    const lastIndex = dataSource.locationLogList.length -1;
                    return <LocationLogMobile conn={conn} item={item} index={index} lastIndex={lastIndex} location={location}/>
                  })
                ) : (
                  <div className={styles.noDataDiv}></div>
                )}
              </div>
              <div className={styles.locationLogListRight}>
                <img className={styles.arrowTop} src="/images/mobile/arrow1.png"></img>
                <img className={styles.arrowBottom} src="/images/mobile/arrow2.png"></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default LocationMobile;
